"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var FocusTrap_1 = require("@oui/core/FocusTrap");
var react_tooltip_lite_1 = require("react-tooltip-lite");
var util_1 = require("../../utils/util");
var Aria_1 = require("../../resources/Aria");
var index_1 = require("../../index");
var types_1 = require("../../configuration/types");
var TActionMenuCell = /** @class */ (function (_super) {
    __extends(TActionMenuCell, _super);
    function TActionMenuCell(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isOpen: false,
            focusIndex: 0
        };
        _this.menuKeydownHandler = function (event) {
            if (!_this.state.isOpen)
                return;
            var actions = _this.props.actions;
            var focusIndex = _this.state.focusIndex;
            var menuItems = util_1.coerceArray(actions);
            var next = function () {
                var idx = focusIndex + 1;
                if (idx < menuItems.length) {
                    _this.setState({ focusIndex: idx });
                }
            };
            var previous = function () {
                var idx = focusIndex - 1;
                if (idx >= 0) {
                    _this.setState({ focusIndex: idx });
                }
            };
            switch (event.key) {
                case "Tab":
                    event.shiftKey ? previous() : next();
                    event.preventDefault();
                    break;
                case "ArrowUp":
                case "ArrowLeft":
                    previous();
                    event.preventDefault();
                    break;
                case "ArrowDown":
                case "ArrowRight":
                    next();
                    event.preventDefault();
                    break;
                case "Home":
                    _this.setState({ focusIndex: 0 });
                    event.preventDefault();
                    break;
                case "End":
                    _this.setState({ focusIndex: menuItems.length - 1 });
                    event.preventDefault();
                    break;
                case "Escape":
                    _this.closeTooltip();
                    break;
            }
        };
        _this.handleButtonClick = function () {
            var isOpen = _this.state.isOpen;
            isOpen ? _this.closeTooltip() : _this.openTooltip();
        };
        _this.handleMenuClick = function (event) {
            if (_this.buttonRef.current &&
                !_this.buttonRef.current.contains(event.target)) {
                _this.closeTooltip();
                event.stopPropagation();
            }
        };
        // Immediate open functions for click event
        _this.openTooltip = function () {
            _this.setState({ isOpen: true }, function () {
                document.addEventListener("click", _this.handleMenuClick);
            });
        };
        _this.closeTooltip = function () {
            _this.setState({ isOpen: false }, function () {
                document.removeEventListener("click", _this.handleMenuClick);
                _this.buttonRef.current && _this.buttonRef.current.focus();
            });
        };
        _this.buttonRef = React.createRef();
        return _this;
    }
    TActionMenuCell.prototype.render = function () {
        var _this = this;
        var _a = this.props, ariaLabel = _a.ariaLabel, actions = _a.actions, label = _a.label;
        var _b = this.state, isOpen = _b.isOpen, focusIndex = _b.focusIndex;
        return (React.createElement(types_1.OuiConfigurationContextConsumer, null, function (_a) {
            var portalClass = _a.portalClass;
            var cellClassName = classNames("oui-table__action-menu__cell", _this.props.portalClass || portalClass, {
                "oui-table__action-menu__cell--active": isOpen
            });
            return (React.createElement(react_tooltip_lite_1.default, { className: cellClassName, tagName: "td", content: React.createElement("div", { className: "oui-table__action-menu__tooltip", hidden: !isOpen, onKeyDown: _this.menuKeydownHandler, role: Aria_1.Roles.Menu },
                    React.createElement(FocusTrap_1.default, { disabled: !isOpen, restoreFocus: false }, util_1.coerceArray(actions).map(function (action, index) {
                        return index === focusIndex ? (React.createElement(FocusTrap_1.default.Inside, { key: index }, action)) : (React.createElement("div", { key: index }, action));
                    }))), direction: "left-start", padding: "0px", distance: 0, arrow: false, isOpen: isOpen },
                React.createElement("button", { "aria-expanded": isOpen, "aria-haspopup": true, className: "oui-table__action-menu__target", onClick: _this.handleButtonClick, ref: _this.buttonRef },
                    React.createElement(index_1.IconElement, { ariaLabel: ariaLabel, label: label, icon: index_1.Icon.MoreVertical, ratio: 0.75 }))));
        }));
    };
    return TActionMenuCell;
}(React.Component));
exports.default = TActionMenuCell;
//# sourceMappingURL=TActionMenuCell.js.map